<template>
  <div class="container">
    <van-nav-bar
      id='van-nav-bar'
      title="订单管理"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="date-box">
      <!-- <div class="title">日期</div>
      <div class="days">{{ searchDay }}</div>
      <div class="button-box">
        <button @click="show = true">选日期</button>
      </div> -->
      <van-cell-group>
        <van-cell title="日期" :value="searchDay" is-link @click="show = true" />
      </van-cell-group>
    </div>
    <div class="data-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
        <OrderItem v-for="item in orderList" :key="item.index" 
        :wechatName="item.wechatName"
        :custMobile="item.custMobile"
        :payType="item.payType"
        :totalprice="item.totalprice"
        :payTime="item.payTime"
        :ordersn="item.ordersn"
        />
      </van-list>
      
    </div>
    <!-- <van-calendar v-model="show" @confirm="onConfirm" :min-date="minDate"/> -->
    <div v-if="show" class="pick-box">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="searchDay"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="onChange"
      />
    </div>
  </div>
</template>
<script>
import OrderItem from "@/components/OrderItem.vue";
import { getOrderList } from "../../utils/api";
import { app } from "../../utils/app";
import { NavBar, DatetimePicker, Cell, CellGroup, List } from "vant";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(DatetimePicker);
Vue.use(NavBar);
Vue.use(Vuex);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(List);

// @ is an alias to /src

export default {
  name: "ShopData",
  components: {OrderItem},
  data() {
    return {
      orderList: [],
      shopToken: "",
      show: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      searchDay: "",
      loading:false,
      finished:false,
      limit:20,
      offset:0
    };
  },
  created() {
    let shopToken = app.storage.get("shopToken");
    this.shopToken = shopToken;
    console.log("shopToken:", this.shopToken);
    this.searchDay = this.timeToDay(new Date());
    // this.getOrderList();
  },
  mounted() {},
  watch: {},
  methods: {
    async getOrderList() {
      let params = {
        limit: this.limit,
        offset: this.offset,
        searchDay: this.searchDay,
        usertoken: this.shopToken,
      };
      let res = await getOrderList(params);
      if (res.data.code == 0) {
        if (res.data.pOrderList&&res.data.pOrderList.length != 0) {
          let newList = this.orderList.concat(res.data.pOrderList)
          this.orderList = newList
          this.loading = false
          this.offset = this.offset + this.limit
        }else{
          this.finished = true
        }
      }
    },
    onClickLeft() {
      this.$router.back();
    },
    //日期选择确认
    onConfirm(value) {
      console.log(value);
      this.orderList=[],
      this.loading=false,
      this.finished=false,
      this.limit=20,
      this.offset=0
      this.searchDay = this.timeToDay(value);
      this.getOrderList();
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    onChange(picker) {
      let value = picker.getValues();
      this.searchDay = `${value[0]}-${value[1]}-${value[2]}`;
    },
    timeToDay(value) {
      let year = value.getFullYear();
      let month =
        value.getMonth() > 8
          ? value.getMonth() + 1
          : `0${value.getMonth() + 1}`;
      let date = value.getDate()> 9? value.getDate(): `0${value.getDate()}`;
      let result = `${year}-${month}-${date}`;
      return result;
    },
    onLoad(){
      this.getOrderList();
      this.loading = true
    }
  },
};
</script>
<style>
.date-box {
  padding: 0 1rem;
  align-items: center;
}
.date-box .title {
  min-width: 4rem;
}
.date-box .days {
  min-width: 4rem;
}
.date-box .button-box {
  min-width: 4rem;
}
.data-wrapper button {
  width: 12.5rem;
  height: 3.125rem;
  margin: 0.625rem;
}
.pick-box {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
</style>
